import { generateAsyncReducer } from '../../../utils';
import { ECareersActions } from './enums';
import { ICareer } from './models';

export const CareersReducer = generateAsyncReducer<ICareer>(ECareersActions.GET_CAREERS);
export const ApplyPositionReducer = generateAsyncReducer<void>(ECareersActions.APPLY_POSITION);
